import { Injectable } from "@angular/core";
import { HttpDataSource } from "@jeanologia/ng-interfaces";
import { Subscription } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class CacheDataSource extends HttpDataSource {
	protected cache = new Map<string, unknown>();

	public set(id: string, value?: unknown) {
		if (value) {
			this.cache.set(id, value);
			return;
		}
		const aux = this.cache.get(id);
		if (aux) {
			return;
		}
		this.cache.set(id, "pending");
		const subscription: Subscription = this.getById(id)
			.pipe(tap((el) => this.cache.set(id, el)))
			.subscribe((res) => subscription.unsubscribe());
	}

	public get(id: string) {
		return this.cache.get(id);
	}

	public setBulk(ids: Array<string>) {
		ids = ids.filter((value, index, self) => self.indexOf(value) === index);
		let query = "";
		const filtered = ids.filter((el) => el !== undefined && this.get(el) === undefined);
		if (filtered.length === 0) {
			return;
		}
		filtered.forEach((id, index) => {
			let pre = "&";
			if (index == 0) {
				pre = "?";
			}
			query += pre + "_id=" + id;

			this.cache.set(id, "pending");
		});
		this.setQuery(query);
		const subscription: Subscription = this.getDataAsObservable()
			.pipe(
				tap((result) => {
					if (result && result.data.length > 0) result = result.data;
					result.forEach((element: any) => {
						this.cache.set(element._id, element);
					});
				}),
			)
			.subscribe((res) => subscription.unsubscribe());

		this.setQuery("");
	}
}
